module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921041149_T.ece74a0c.jpg";